<template>
  <v-container fill-height elevation="16" variant="outlined">
    <v-row justify="center" align="center">
        <v-col cols="12" sm="4">
    <v-card 
      class="mx-auto"
      max-width="344"
      title="Connexion"
      variant="outlined"
    >
      <v-container >
     
        <v-text-field
          v-model="data.email"
          color="primary"
          label="Identifiant"
          variant="outlined"
          @focus="loginError=false"
          hint="Email"
        ></v-text-field>
  
        <v-text-field
          v-model="data.password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          color="primary"
          label="Mot de passe"
          placeholder="Saisir un mot de passe"
          variant="outlined"
          @focus="loginError=false"
          @click:append="show1 = !show1"
        ></v-text-field>
  
      </v-container>
  
      <v-divider></v-divider>
  
      <v-card-actions>
        <v-spacer></v-spacer>
      
        <v-btn  color="blue-darken-4"
         class="text-none ms-4 text-white" @click="valider()" >
          Connexion  
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-alert color="red" v-if="loginError" justify="center">Identifiant ou mot de passe incorrect</v-alert>
    </v-col>
  

    </v-row>
    </v-container>
  </template>
  <script>
  import axios from 'axios'
import http from '../../http.js'
//  import { useAuthStore } from './../../store/store.js'
  //import { useAuthStore } from '@store'
  export default {
    
    data: () => ({
      show1:false,
      prenom: null,
      nom: null,
      email: null,
      password: null,
      loginError:false,  
      items:['admin','utilisateur'],
      data:{}
    
    }),
    mounted(){
      this.modifier()

    },
    methods:{
      async valider(){

        try{
          this.loginError=false;
        const auth='Basic '+window.btoa(this.data.email + ':' + this.data.password)
        const user = await axios.post(http.API_HOST+'/api/login', {},{headers:{ 'Authorization':auth}});
       
        localStorage.setItem('user',JSON.stringify(user.data))
        localStorage.setItem('accessKey',user.data.accessKey)
        this.$router.push('/')
      } catch (error) {
        this.loginError=true      
      }
    //     const authStore = useAuthStore();
 
    // return authStore.login(this.data.email, this.data.password)
    //     .catch(error => alert(error));

         // if(this.$route.params.id ==undefined){
          
            // http.post("/login",this.data).then( this.creation=false);
            // this.$router.push('/user/listuser')
          } ,
          modifier(){
           
            if(this.$route.params.id !=undefined){
              http.get("/api/utilisateur/"+this.$route.params.id).then( res=>{this.data=res.data});

            }
          } 
    }
  }
</script>